<template>
    <div v-if="modifications.length && !loading" class="modification_toolbar mr-2">
        <v-menu
      v-model="menu"
      :close-on-content-click="false"
      
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="green"
          dark
          v-bind="attrs"
          v-on="on"
        small
        >
          {{modifications.length}} Unsaved Changes
        </v-btn>
      </template>

      <v-card class="pa-4">

          <div v-for="m in modifications"  class="modification-box" v-bind:key="m.spw.ID">
            <div class="subtitle-2 mod-spw" style="max-width:600px"><v-icon small class="pr-1" v-on:click="clearChanges({itemID:m.spw.ID})">clear</v-icon>{{m.spw.Sub_Project_Work_Name_SPW}}</div>
            <div class="change-list-container">
                <table class="change-list">
                <tr v-for="(change, index) in Object.entries(m.modifications)" class="change-box" v-bind:key="index">
                    <td class="overline change-field ">{{change[0]}}</td><td class="caption pa-0 ma-0 change-description">{{change[1].old}} <v-icon>arrow_right_alt</v-icon> {{change[1].new}}</td>
                </tr>    
                </table>
            </div>
          </div>

    

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="#666666" dark small @click="clearChanges">Clear Changes</v-btn>
          <v-btn color="green" dark small @click="saveToZoho" :loading="saving">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    </div>
</template>



<script>
import { mapState } from 'vuex'
    import { mapGetters } from 'vuex'
        import { mapMutations } from 'vuex'
        import { mapActions } from 'vuex'
  export default {
    data: () => ({
     menu: false
    }),
    mounted() {

    },
    methods: {
        ...mapMutations(['clearChanges']),
        ...mapActions(['saveToZoho'])

    },
    computed:{
        ...mapState(['saving','loading']),
        ...mapGetters(['modifications'])

    },
    beforeDestroy(){

    }
  }
</script>

<style>
.mod-spw{
    white-space:nowrap;
    overflow:hidden;
    text-overflow: ellipsis;
    background-color:#dfdfdf;
    padding: 5px;
}
.modification-box{
    border: solid 1px #dfdfdf;

}
.change-list{
    width: 100%; 

}
.change-list-container{
    margin: 10px;
}
.change-field{
    color:navy;
    padding-right: 20px;
}
.change-box{

}
.change-description{
    text-align: right;
}
</style>